import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { isEmpty } from 'lodash'
import { Typography, Card, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import axios from 'axios'
const { Title, Paragraph, Text } = Typography;

const FinishForm = () => {
  return (
    <Row type="flex" justify="center" align="middle">
      <Col>
        <Card title={<Title level={2}>ลงทะเบียนสำเร็จ</Title>}
          headStyle={{ textSizeAdjust: '100', textAlign: 'center' }} bordered={true}>
          <Typography>
            <Paragraph>
              In the process of internal desktop applications development, many different design specs and
              implementations would be involved, which might cause designers and developers difficulties and
              duplication and reduce the efficiency of development.
            </Paragraph>
            <Paragraph>
              After massive project practice and summaries, Ant Design, a design language for background
              applications, is refined by Ant UED Team, which aims to
              <Text strong>
                uniform the user interface specs for internal background projects, lower the unnecessary
                cost of design differences and implementation and liberate the resources of design and
                front-end development
              </Text>
              .
            </Paragraph>
            <Title level={2}>Guidelines and Resources</Title>
            <Paragraph>
              We supply a series of design principles, practical patterns and high quality design resources
              (<Text code>Sketch</Text> and <Text code>Axure</Text>), to help people create their product
              prototypes beautifully and efficiently.
            </Paragraph>

            <Paragraph>
              <ul>
                <li>
                  <a href="/docs/spec/proximity">Principles</a>
                </li>
                <li>
                  <a href="/docs/pattern/navigation">Patterns</a>
                </li>
                <li>
                  <a href="/docs/resource/download">Resource Download</a>
                </li>
              </ul>
            </Paragraph>
          </Typography>
        </Card>
      </Col>
    </Row>
  )
}

const WrappedFinishForm = Form.create({ name: 'FinishForm' })(
  FinishForm
)
export default WrappedFinishForm



// WEBPACK FOOTER //
// ./src/pages/CreateBrand/FinishForm/index.js